(function(){
  var BAD = [/fonts\.cdnfonts\.com/i]; // add more domains if needed
  function isBadHref(h){ return h && BAD.some(function(r){return r.test(h);}); }
  function nuke(el){ try{ el.parentNode && el.parentNode.removeChild(el); }catch(e){} }

  // Remove any existing LINK/STYLE that pull those fonts
  document.querySelectorAll('link[rel="stylesheet"],style').forEach(function(n){
    var href = n.href || '';
    var txt  = n.textContent || '';
    if (isBadHref(href) || isBadHref(txt)) nuke(n);
  });

  // Watch the DOM for future injections
  new MutationObserver(function(ms){
    ms.forEach(function(m){
      m.addedNodes && m.addedNodes.forEach(function(n){
        if(!n || n.nodeType!==1) return;
        if(n.nodeName==='LINK' && n.rel==='stylesheet' && isBadHref(n.href)) return nuke(n);
        if(n.nodeName==='STYLE' && isBadHref(n.textContent||'')) return nuke(n);
      });
    });
  }).observe(document.documentElement,{subtree:true,childList:true});
})();
